module.exports = __webpack_public_path__ + "img/CentralMineralBath-Sofia-8a_3.45ff4867.jpg";